// @flow
import React from 'react'
import renderHTML from 'react-render-html'
import { Accordion, Icon } from 'semantic-ui-react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'

export default class Tab extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  render() {
    const isActive = this.props.activeIndex.includes(this.props.index)
    return (
      <div className={isActive ? 'tab active' : 'tab'}>
        <Accordion.Title
          active={isActive}
          index={this.props.index}
          onClick={this.props.handleClick}
        >
          <div className='question'>{renderHTML(this.props.title)}</div>
          <div className='arrow'>
            <Icon name={isActive ? 'close' : 'angle down'} size={isActive ? 'small' : undefined}/>
          </div>
        </Accordion.Title>
        <Accordion.Content
          active={this.props.activeIndex.includes(this.props.index)}
        >
          {this.props.children}
        </Accordion.Content>
      </div>
    )
  }
}
